import { Call, TwilioError } from '@twilio/voice-sdk';
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- kept for when the bitrate test below is re-enabled
import { DiagnosticError } from '@twilio/rtc-diagnostics';
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- kept for when the bitrate test below is re-enabled
import { bitrateTestRunner, preflightTestRunner } from '../Tests/Tests';
import { Edge, TestResults, NetworkTestName } from '../../../../types';
import { useState, useCallback } from 'react';
import axios from 'axios';
import { TOKEN_API_URL } from '../../../../constants';

export default function useTestRunner() {
  const [isRunning, setIsRunning] = useState(false);
  const [activeTest, setActiveTest] = useState<NetworkTestName>();
  const [result, setResult] = useState<TestResults | null>(null);
  const [activeEdge, setActiveEdge] = useState<Edge>();

  const getVoiceToken = useCallback(async () => {
    try {
      const response = await axios(TOKEN_API_URL, { method: 'POST' });
      return response.data.token;
    } catch (error) {
      console.error('Error fetching the voice token', error);
      throw error;
    }
  }, []);

  const runTests = useCallback(
    async (edge: Edge, codecPreferences: Call.Codec[]) => {
      setIsRunning(true);
      setResult(null);
      const testResult: TestResults = {
        edge,
        results: {},
        errors: {},
      };

      setActiveEdge(edge);
      setActiveTest('Preflight Test');

      try {
        const voiceToken = await getVoiceToken();
        testResult.results.preflight = await preflightTestRunner(edge, voiceToken, codecPreferences);
      } catch (err) {
        testResult.errors.preflight = err as TwilioError.TwilioError;
      }

      // TODO: Re-enable bitrate test once we can get the turn credentials from the control service
      /*if (!testResult.errors.preflight) {
        setActiveTest('Bitrate Test');
        try {
          testResult.results.bitrate = await bitrateTestRunner(edge);
        } catch (err) {
          testResult.errors.bitrate = err as DiagnosticError;
        }
      }*/

      setResult(testResult);

      setActiveTest(undefined);
      setActiveEdge(undefined);
      setIsRunning(false);
      return testResult;
    },
    [getVoiceToken]
  );

  return {
    isRunning,
    activeTest,
    result,
    activeEdge,
    runTests,
  };
}
